module.exports = __webpack_public_path__ + "img/2010 radtour ehrenabteilung 022.ea09fa83.jpg";